import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[sdMaxNumber]',
  standalone: true,
})
export class MaxNumberDirective implements OnInit, OnDestroy {
  @Input('sdMaxNumber') maxNumber: number;
  @Input() formControl: FormControl;

  private subscription = new Subscription();

  ngOnInit(): void {
    this.subscription.add(
      this.formControl?.valueChanges.subscribe((value: number) => {
        if (value > this.maxNumber) {
          this.formControl.setValue(this.maxNumber);
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
